import Slider from "react-slick";
import DestinationCard from "./DestinationCard";
import { useAppSelector } from "../../app/hooks";

const DestinationSection = () => {
  const sectors = useAppSelector((state) => state.home.sectors);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <div className="destination-section mt-4">
      <div className="container">
        <h2>
          Popular <span>Destinations</span>
        </h2>
        <Slider {...settings}>
          {sectors.map((destination, index) => (
            <DestinationCard destination={destination} key={index} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default DestinationSection;
